<template>
    <div class="transferencia-form">
        <div v-if="showFields">
        <p>Si planea transferir luego, puede encontrar la compra en <i>Mis compras pendientes</i> dentro de su <router-link to="/perfil">perfil</router-link>.</p>
            <p class="text-left alert-text-box">
                <b>Datos Bancarios donde debes transferir:</b><br>
                Celcom S.A.<br>
                Banco Chile<br>
                Cuenta corriente 4720052610<br>
                RUT 76.023.762-0<br>
                Email ventas@topclass.cl
            </p>
        <form @submit.prevent="submit"
            ref="transferencia-form-form"
            novalidate
            :class="{
                'was-validated': validated
            }">
            <div class="form-group">
                <input type="text"
                    class="form-control"

                    aria-describedby="numeroHelp"
                    placeholder="Número de transferencia realizada"
                    required
                    v-model="numero">
                <div class="invalid-feedback">Número inválido</div>
            </div>
            <div class="form-group">
                <input type="text"
                    class="form-control"

                    aria-describedby="nombreHelp"
                    placeholder="Nombre"
                    required
                    v-model="nombre">
                <div class="invalid-feedback">Nombre inválido</div>
            </div>
            <div class="form-group">
                <div class="form-group">
                    <label for="login-form-genero">Banco</label>
                    <select
                        :class="'form-control ' + (validated && banco == '' ? 'is-invalid': '')"
                        name="banco"
                        
                        aria-describedby="bancoHelp"
                        placeholder="Banco"
                        required
                        v-model="banco">
                        <option v-for="(ban, i) in bancos"
                            :key="i"
                            :value="ban">
                            {{ ban }}
                        </option>
                    </select>
                    <div class="invalid-feedback">Este campo no puede ir vacío.</div>
                </div>
            </div>
            <div class="form-group text-center">
                <button class="btn btn-primary w-100 btn-noradius">
                    Enviar
                    <spinner v-if="isSubmitting" />
                </button>
            </div>

            <div class="transferencia-form-message" v-html="transferenciaMessage">

            </div>

        </form>
        </div>
        <div v-else
            class="text-center alert-text-box">
            <p :class="{
                       'color-gray': compraExito
                       }">{{ transferenciaMessage }}</p>
        </div>
    </div>
</template>

<script>
import Spinner from "./Spinner";
import bancos from "../bancos.json";

export default {
	components: { Spinner },
	props: ["id_compra"],
	data() {
		return {
			numero: "",
			nombre: "",
			banco: "",
			validated: false,
			isSubmitting: false,
			transferenciaMessage: "",
			bancos,
			showFields: true,
            compraExito:false
		};
	},
	watch: {},
	methods: {
		submit() {
			this.validated = true;
			this.transferenciaMessage = "";
			if (this.nombre != "" && this.numero != "" && this.banco != "") {
				this.isSubmitting = true;
				this.$store
					.dispatch("transferencia", {
						nombre: this.nombre,
						numero: this.numero,
						banco: this.banco,
						id_compra: this.id_compra
					})
					.then(response => {
						console.log("response transferencia", response);
						this.transferenciaMessage =
							"Información registrada, tu pago con transferencia será validado dentro de las próximas horas.";
						this.validated = false;
						this.$emit("ok", response);
						this.isSubmitting = false;
						this.nombre = "";
						this.numero = "";
						this.banco = "";
						this.showFields = false;
                        this.compraExito=true;

						// Actualizar compras de usuario.
						this.$store.dispatch("getUserCompras").catch(error =>
							console.log("error getUserCompras", error)
						);

						// Cargar videos de usuario
						this.$store.dispatch("getUserVideos").catch(error =>
							console.log("error getUserVideos", error)
						);
						console.log("finish transferencia", response);

                    this.$router.push({
					name: "CheckoutFinish",
					params: {
						pasarela :"transferencia",
						estado: "aprobado",
						id_compra:this.id_compra,
					}
				});

					})
					.catch(error => {
						this.transferenciaMessage =
							"Error al registrar el pago, por favor intente de nuevo.";
						this.$emit("error", error);
						this.isSubmitting = false;
					});
			} else {
				this.transferenciaMessage = "Debe colocar los 3 datos.";
			}
		}
	}
};
</script>

